import { RouteConfig } from "vue-router";

export const RTasksBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "tasks-browse" */
      "./VTasksBrowse.vue"
    ),
  meta: {
    title: "Tasks",
  },
};
